export default {
  otherDocDetail: {
    viewClient: 'VISTA CLIENTE',
    viewStaff: 'VISTA STAFF',
    copyLmdx: 'COPIAR LMDX',
    downloadCropped: 'DESCARGAR RECORTADO',
    runningInfo: 'Información de ejecución:',
    errors: 'Errores:'
  },
  ViesValidator: {
    documents: "Documents",
    upload_documents: "Pujar documents",
    actions: "ACCIONS",
    add_filter: "Afegir filtre",
    delete_documents: "Esborrar documents",
    continue_workflow: "Reintentar",
    restart_workflow: "Reiniciar",
    refresh: "Actualitzar",
    download_documets: "Descarregar documents",
    download:"Descarregar",
    change_workflow: "Canviar Workflow",
    relaunch_workflow: "Rellançar Workflow",
    move_to_a_folder: "Moure a una carpeta",

    // popup eliminar docs
    warning_delete: "S'eliminaran els documents seleccionats.",
    warning_delete_2: "Està segur?",
    checkbox_text: "Esborrar registres associats",
    cancel: "Cancel·lar",
    delete: "Esborrar",

    modify_workflow: "Modificar workflow",
    change: "Canviar",

    select_folder_tooltip: "Seleccionar carpeta",
    select_folder: "Selecciona la carpeta destinació",
    create_folder: "Crear carpeta",
    hide_my_unit: "Amagar la Meva unitat",
    create: "Crear",
    accept: "Acceptar",
    folder_name: "Nom de la carpeta",
    privacy_label: "Marcar com a privada",

    delete_folder: "Esborrar carpeta",
    warning_delete_folder: "Està segur que voleu suprimir la carpeta seleccionada?",
    delete_folder_only: "Esborrar només la carpeta (mantenir el contingut)",
    delete_folder_recursively: "Esborrar carpeta i tot el contingut",
    delete: "Esborrar",

    edit_folder: "Editar carpeta",
    name_folder: "Nom de la carpeta",
    edit: "Editar",

    id: "Id",
    document_name: "Nom del document",
    document_type: "Tipus de document",
    upload_data: "Data de pujada",
    workflow: "Workflow",
    state: "Estat",
    folder_path: "Ruta",
    search_all_documents: "Cercar en tots els documents...",
    search_results_global: "Resultats de \"{term}\" en totes les carpetes ({count} documents)",

    payroll: "Nòmina",
    contract: "Contracte",
    model_tax: "Models/Impostos",
    certificate: "Certificat",
    bill: "Factura",
    other: "Altres",
    pending: "Pendent",
    waiting_approval: "Pendent d'aprovació",
    waiting: "En espera",
    approved: "Aprovat",
    rejected: "Rebutjat",
    insufficient_credits: "Saldo insuficient",
    lost_workflow: "Error workflow desaparegut",
    no_workflow: "Sense workflow",
    error: "Error",
    done: "Completat",
    WaitForApproval: "Esperar aprovació",
    AskAI: "Extracció d'informació amb IA",
    AddDocumentRepresentationToConversation: "Afegir representació del document a la conversa",
    CompleteConversation: "Completar conversa amb IA",
    UploadAsInvoice: "Pujar com a factura",
    SendThroughEmail: "Enviar per correu electrònic",
    SendEmailWithTemplate: "Enviar correu electrònic amb plantilla",
    LookupAndMatchInstance: "Cercar i adjuntar registre",
    LookupAndMatchMultipleInstances: "Cercar i adjuntar diversos registres",
    ExtractInstanceFromRawData: "Extreure registre prèviament injectat",
    CreateInstanceFromContext: "Crear registre a partir del context",
    CreateInstance: "Crear registre",
    CreateInstancesFromList: "Crear registres a partir d'una llista",
    AddInstanceToList: "Afegir registre a la llista",
    ModifyContext: "Modificar registre",
    DeleteContextInstance: "Eliminar registre",
    PayrollAccounting: "Comptabilitzar nòmina",
    SendDataToEndpoint: "Enviar dades a un endpoint",
    NotifyCounterpart: "Notificar a la contrapart",
    RunCommand: "Executar comandament",
    RunQuery: "Executar consulta",
    RunWorkflow: "Executar workflow",
    RunScript: "Executar script de Python",
    SplitFile: "Separar pàgines fitxer",
    ExtractTextFromDocument: "Extreure text del document",

    docs_per_page: "Documents per pàgina",
    of: "de",

    "not_same_wf":"Tots els documents seleccionats han de tenir el mateix workflow.",

    my_unit: "La meva unitat",
    new: "Nou",

    label_name: "Nom",
    label_type: "Tipus",
    label_date_from: "Data des de",
    label_date_to: "Data fins",
    label_pending_my_approval: "Pendent de la meva aprovació",

    //mobile
    filters: "Filtres",
    type_of_document: "Tipus de doc",
    date: "Data",
  },
  AddFilterDocuments: {
    add_filter: "Afegir filtre",
    see_invoices: "Veure factures",
  },
  PDFDocumentV2: {
    invoice_detail: "Detall de la factura",
    doc_detail: "Detall del document",
    upload_invoice: "Pujar factura",
  },
  GeneralWorkflowDetail: {
    continue_workflow: "Reintentar",
    state: 'Estat',

    pending: "Pendent",
    waiting_approval: "Pendent d'aprovació",
    approved: "Aprovat",
    rejected: "Rebutjat",
    insufficient_credits: "Saldo insuficient",
    lost_workflow: "Error workflow desaparegut",
    error: "Error",
    done: "Completat",
    WaitForApproval: "Esperar aprovació",
  },
  AppSearchAddFilterBtn: {
    add_filter: 'Afegir filtre',
    delete_filters: 'Esborrar filtres',
    filter: "Filtre",
  },
  AppSearchFilterChip: {
    value: "Valor",
    payroll: "Nòmina",
    contract: "Contracte",
    taxes_and_models: "Models/Impostos",
    certificate: "Certificat",
    invoices: "Factures",
    others: "Altres",
    all: "Tots",
    yes: "Sí",
    no: "No",
    no_options_available: "No hi ha opcions disponibles",
  },
  OtherDocWorkflowDetail: {
    staff_view: 'VISTA STAFF',
    client_view: 'VISTA CLIENT',

    copy_lmdx: 'COPIAR LMDX',
    download_cropped: 'DESCARREGAR RETALLAT',
  },
  CommentSectionComponent: {
    no_comments: "No hi ha comentaris",
    write_your_comment: "Escriu el teu comentari...",
  },
  ExtractedDataComponent: {
    extracted_information: "Informació extreta",
  },
  GenericDocumentLoader: {
    upload_documents: "Pujar documents",
    title_upload_docs: "Des d'aquí pots pujar tots els documents",
    subtitle: "Pot ser en format pdf/jpg/png",
    drag_files: "Arrossegueu aquí els vostres fitxers o feu clic per seleccionar fitxers des de carpeta",
    document_type: "Tipus de document",
    invoice_type: "Tipus de factura",

    add_type: "Afegir tipus",
    edit_workflows: "Editar workflows",

    my_unit: "La meva unitat",
    select_location: "Seleccionar ubicació",
    select_folder: "Selecciona la carpeta destinació",
    cancel: "Cancel·lar",
    accept: "Aceptar",

    payroll: "Nòmina",
    contract: "Contracte",
    taxes_and_models: "Models/Impostos",
    certificate: "Certificat",
    invoices: "Factures",
    others: "Altres",
    add_type: "Afegeix tipus",

    out_invoice: 'Factura de client',
    in_invoice: 'Factura de proveïdor',

    types_of_documents: "Tipus de documents",
    name: "Nom",
    close: "Tancar",
    save: "Guardar",

    no_workflow: "Sense workflow",

    drag_files_mobile: "Arrossegueu aquí els vostres documents",
  },
  WorkflowList: {
    refresh: "Actualitzar",
  },
  SelectorEmpresa: {
    company: "Empresa",
  },
  App: {
    invoices: "Comptabilitat",
    suppliers: "Proveïdors",
    customers: "Clients",
    banks: "Bancs",
    electronic_invoice: "Factura Electrònica",
    gestor_ia: "Gestor IA",
    invoice_approval: "Aprovació de factures",
    documents: "Documents",
    my_records: "Els meus Registres",
    remesas: "Remeses",
    payrolls: "Nòmines",
    dashboard: "Panell de Control",
    clock_in: "Control Horari",
    tickets: "Tickets",
    persons: "Persones",
    settings: "Configuració",
    trash: "Paperera",      

    my_companies: "Les meves Empreses",
    manager_summary: "Quadre Resum Gestor",
    accounting_summary: "Quadre Resum Comptabilitat",
    configuration: "Configuració",
    my_data: "Les meves Dades",
    my_expenses: "Les meves Despeses",
    guidelines: "Guidelines",
    functionalities: "Funcionalitats",
    kpis: "KPIs",
    access_log: "Registre D'accés",
    backup_log: "Registre de Backups",
    network_drives: "Unitats de xarxa",
    whats_new: "Novetats",
    log_out: "Tancar sessió",
    tariffs_management: "Gestió de tarifes",
    client_tariff: "Tarifa del client",
    users: "Usuaris",
    locations: "Ubicacions",
    download_client: "Descarregar Client",
    onboard_info: "Informació Onboard",
    reports: "Informes",
    bank_summary: "Quadre Resum Bancs",
    contracts_kpis: "Contractes KPIs",
    supplier_prompts_ai: "Prompts per a tercers IA"
  },
  UserConfiguration: {
    header: "Configuració de l'usuari",
    title1: "Configura el teu usuari per aprofitar Inmatic al màxim",
    title2: "Configura el teu usuari per aprofitar el programa al màxim",
    body: "Aquí podràs trobar les opcions autogestionables perquè aconsegueixis configurar el teu usuari."
  },
  ListObject: {
    companies: "Empreses",
    configuring: "Configurant...",
    per_page: "per pàgina",
    of: "de",

    id: "Id",
    company_name: "Nom de empresa",
    company_cif: "CIF Empresa",
    route: "Ruta",
    state: "Estat",
    type: "Tipus",
  },
  ConnectorList:{
    companies: "Empreses",
  },
  PopupCreateCompany: {
    create_companies: "Crear una empresa",
    edit_company: "Editar Empresa",
    company_name: "Nom de l'empresa",
    company_cif: "Cif de l'empresa",
    cancel: "Cancel·lar",
    edit: "Editar",
    create: "Crear",
    save: "Guardar",
  },
  ItemFilterDocuments: {
    name: "Nom",
    type: "Tipus",
    date_from: "Data des de",
    date_to: "Data fins",
    pending_my_approval: "Pendent de la meva aprovació",

    payroll: "Nòmina",
    contract: "Contracte",
    taxes_and_models: "Models/Impostos",
    certificate: "Certificat",
    invoices: "Factures",
    others: "Altres",
    all: "Tots",

    yes: "Sí",
    no: "No",
  },
  Connector2List: {
    create_company: "Crear empresa",
    refresh: "Refrescar",
    companies: "Empreses",
    id: "Id",
    name: "Nom",
    cif: "CIF"
  },
  narcisTest:{
    'title': "Prova d'en Narci",
  }
}
